import { t } from "@/i18n-js/instance";
import { Form } from "@/react/components/shared/uikit/Form";
import { Icon } from "@circle-react-shared/Icon";
import { TippyV2 } from "@circle-react-shared/TippyV2";
import { Typography } from "@circle-react-shared/uikit/Typography";

interface CountdownTypeRadioProps {
  name: string;
  translationRoot: string;
}

export const CountdownTypeRadio = ({
  name,
  translationRoot,
}: CountdownTypeRadioProps) => (
  <Form.RadioGroup
    name={name}
    variant="radio"
    verticalSpacing="tightest"
    options={[
      {
        label: (
          <span className="flex flex-row gap-x-2">
            <Typography.BodySm>
              {t([translationRoot, "countdown_type.remaining_time"])}
            </Typography.BodySm>
            <TippyV2
              content={t([
                translationRoot,
                "countdown_type.remaining_time_tooltip",
              ])}
            >
              <Icon type="question-mark" className="icon icon--xs" />
            </TippyV2>
          </span>
        ),
        value: "remaining_time",
      },
      {
        label: (
          <span className="flex flex-row gap-x-2">
            <Typography.BodySm>
              {t([translationRoot, "countdown_type.finish_at"])}
            </Typography.BodySm>
            <TippyV2
              content={t([translationRoot, "countdown_type.finish_at_tooltip"])}
            >
              <Icon type="question-mark" className="icon icon--xs" />
            </TippyV2>
          </span>
        ),
        value: "finish_at",
      },
    ]}
  />
);
